import { render, staticRenderFns } from "./nonmoving.vue?vue&type=template&id=502b2bdc&scoped=true&"
import script from "./nonmoving.vue?vue&type=script&lang=js&"
export * from "./nonmoving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b2bdc",
  null
  
)

export default component.exports